import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";
import { PageHero, SectionLabel, EnquiryBanner } from "@/components/site/Sections";
import { ShieldCheck, Handshake, PackageCheck, Factory } from "lucide-react";
import { MILLS } from "@/lib/data";

const STRENGTHS = [
  { icon: Factory, title: "Trusted sourcing network", body: "Direct associations with established mills give us reliable access to quality stock." },
  { icon: ShieldCheck, title: "Quality-backed supply", body: "Grades from reputable mills mean consistent performance you can plan production around." },
  { icon: Handshake, title: "Strong relationships", body: "Long-standing dealer and distributor ties translate into better availability and terms." },
  { icon: PackageCheck, title: "Confidence in origin", body: "You always know where your paper comes from — and that it meets the mark." },
];

const Mills = () => (
  <div data-testid="mills-page">
    <PageHero
      label="Mills & Associations"
      title="A sourcing network the trade can rely on."
      subtitle="Our relationships with established Indian paper mills are the backbone of our consistent, quality-backed supply."
    />

    <section className="relative z-10 pb-8 lg:pb-4">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Stagger className="grid gap-6 md:grid-cols-2">
          {MILLS.map((m, i) => (
            <StaggerItem key={m.name}>
              <div data-testid={`mill-card-${i}`} className="h-full bg-surface border border-paper-border rounded-sm p-9 lg:p-10 transition-colors duration-300 hover:border-forest">
                <span className="font-mono text-sm text-gold">0{i + 1}</span>
                <h2 className="mt-4 font-serif text-3xl lg:text-4xl text-forest">{m.name}</h2>
                <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.24em] text-ink-soft">{m.focus}</p>
                <p className="mt-5 text-ink-soft leading-relaxed">{m.note}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>

    <section className="relative z-10 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-14 max-w-2xl">
          <Reveal><SectionLabel>What it means for you</SectionLabel></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-forest leading-tight">
              Why our network is your advantage.
            </h2>
          </Reveal>
        </div>
        <Stagger className="grid gap-px bg-paper-border border border-paper-border rounded-sm overflow-hidden sm:grid-cols-2 lg:grid-cols-4">
          {STRENGTHS.map((s) => (
            <StaggerItem key={s.title} className="bg-paper p-9">
              <s.icon className="h-8 w-8 text-forest" strokeWidth={1.5} />
              <h3 className="mt-5 font-serif text-xl text-forest">{s.title}</h3>
              <p className="mt-3 text-sm text-ink-soft leading-relaxed">{s.body}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>

    <EnquiryBanner />
  </div>
);

export default Mills;
